import Base from './Base'

class InvalidElement extends Base {
  // @todo async render -> console.error(`Invalid element of type ${type}`);
}

export default InvalidElement
